export default __webpack_public_path__ + "static/media/Deactive.b679336b.svg";